var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 17.5,
    viewBox: "0 0 14 17.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "description_FILL0_wght400_GRAD0_opsz48",
    d: "M11.478,17.781h7.044V16.469H11.478Zm0-3.719h7.044V12.75H11.478ZM9.313,21.5A1.346,1.346,0,0,1,8,20.188V5.313A1.346,1.346,0,0,1,9.313,4h7.9L22,8.791v11.4A1.346,1.346,0,0,1,20.688,21.5ZM16.553,9.381V5.313H9.313V20.188H20.688V9.381ZM9.313,5.313v0Z",
    transform: "translate(-8 -4)",
    fill: "#1f2747"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavList);
export default __webpack_public_path__ + "static/media/nav-list.81d84717ce5fe5c1cc1410ec8e422883.svg";
export { ForwardRef as ReactComponent };